module.exports = __webpack_public_path__ + "img/iPhoneX.c1d421f4.png";